import { get, post } from '@/common/request';

/**
 * 一级行业下拉项
 * https://yapi.lanhanba.com/project/602/interface/api/75998
 */
export function getLcnSelectionIndustry(params) {
  return get('/map/lcn/selection/industry/oneClass', params, { needCancel: false, isMock: false, mockId: 602, mockSuffix: '/api' });
}

/**
 * 项目列表
 * https://yapi.lanhanba.com/project/602/interface/api/75200
 */
export function getLcnPlaceList(params) {
  return post('/map/lcn/placeList', params, { needCancel: false, isMock: false, mockId: 602, mockSuffix: '/api' });
}

/**
 * 项目概览
 * https://yapi.lanhanba.com/project/602/interface/api/75711
 */
export function getLcnPlaceListDetail(params) {
  return post('/map/lcn/placeList/detail', params, { needCancel: false, isMock: false, mockId: 602, mockSuffix: '/api' });
}

/**
 * 项目点位列表
 * https://yapi.lanhanba.com/project/602/interface/api/75585
 */
export function getLcnPlaceSpotList(params) {
  return post('/map/lcn/place/spotList', params, { needCancel: false, isMock: false, mockId: 602, mockSuffix: '/api' });
}
